




















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import Helpers from "@/helpers/helper";
import SolicitudCambioComposicionFamiliar, {
  SolicitudCambioComposicionFamiliarExclusion,
  SolicitudCambioComposicionFamiliarDocumento
} from "@/models/tramite/solicitud-cambio-composicion-familiar/";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import NameValue from "@/models/nameValue.model";
import TipoTramite from "@/models/tipoTramite";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";

@Component({
  components: {
    DatePickerComponent
  }
})
export default class CambioComposicionFamiliarExclusion extends BaseVue {
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly codigoDocAdicionales!: string;
  @Prop() readonly tipoTramite!: TipoTramite;

  miembroTableConfig: BTableConfig<Miembro> | null = null;
  model = new SolicitudCambioComposicionFamiliar();
  nameValue = new NameValue();

  constructor() {
    super();
    this.model.exclusion = true;
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp(
        "codigoDocAdicionales",
        "string",
        true,
        "Código de docs. adicionales"
      )
    );
    let contenido = this.content as any;
    if (contenido) {
      let main = (contenido.solicitudCambioComposicionFamiliar = new SolicitudCambioComposicionFamiliar(
        undefined
      ));
      main.exclusion = true;
      contenido.solicitudCambioComposicionFamiliar = main;
      this.$emit("update:content", contenido);
    }
    this.$emit("render", props);
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId) {
      let contenido = this.content as any;
      if (contenido) {
        contenido.solicitudCambioComposicionFamiliar.hogarId = this.beneficiario.hogarId;
        this.$emit("update:content", contenido);
      }
      return this.beneficiario.hogarId;
    }
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido.solicitudCambioComposicionFamiliar)
        delete contenido.solicitudCambioComposicionFamiliar;

      this.$emit("update:content", contenido);
    }
  }
  onLoadTable(config: BTableConfig<Miembro>) {
    this.miembroTableConfig = config;
    this.miembroTableConfig.checking.isCheckableRow = (row: Miembro) =>
      row.parentescoCodigo !== Helpers.Codes.Parentesco.JefeHogar;
  }
  onCheck(list: Miembro[], current: Miembro) {
    if (!list.length) this.model.miembrosExcluidos = [];

    if (current) {
      var exite = list.find(x => x.personaId === current.personaId);
      if (!exite) {
        var ind = this.model.miembrosExcluidos.findIndex(
          x => x.personaId === current.personaId
        );
        if (ind >= 0) this.model.miembrosExcluidos.splice(ind, 1);
      }
    }
    list.forEach(m => {
      let member = this.model.miembrosExcluidos.find(x => x.personaId === m.personaId);
      if (!member) {
        let val = new SolicitudCambioComposicionFamiliarExclusion(
          this.beneficiario.hogarId,
          m.id,
          m.personaId
        );
        val.codHogar = m.codigoHogar;
        val.persona = m.persona;
        val.parentescoNombre = m.parentescoNombre;
        val.cedulaQuienPoseeMenor = m.cedulaQuienPoseeMenor;
        val.parentescoQuienPoseeMenorId = m.parentescoQuienPoseeMenorId;
        val.razonExclusionId = m.razonExclusionId;
        val.razonMuerte = m.razonMuerte;
        val.fechaFallecimiento = m.fechaFallecimiento;
        this.model.miembrosExcluidos.push(val);
      }
    });
  }
  removeMiembro(
    inx: number,
    miembro: SolicitudCambioComposicionFamiliarExclusion
  ) {
    //let index = this.model.miembrosExcluidos.findIndex(x => x.id === miembro.miembroId);
    this.model.miembrosExcluidos.splice(inx, 1);
  }
  onChangeDocs(miembro: SolicitudCambioComposicionFamiliarExclusion, tipos: any, docs: any[]) {
    miembro.documentos = docs.map(x => {
        let doc = new SolicitudCambioComposicionFamiliarDocumento();
        doc.personaId = miembro.personaId;
        doc.documentoId = x.documentoId;
        doc.documento = x.documento;
        doc.tipoDocumentoId = x.tipoDocumentoId;
        doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
        return doc;
      });
  }
  @Watch("model", { deep: true })
  set(model: SolicitudCambioComposicionFamiliar) {
    let contenido = this.content as any;
    if (contenido) {
      contenido.solicitudCambioComposicionFamiliar = this.map(model);
      contenido.solicitudCambioComposicionFamiliar.miembrosExcluidos.forEach(
        (x: any) => {
          if (x.cedulaQuienPoseeMenor) {
            x.cedulaQuienPoseeMenor = x.cedulaQuienPoseeMenor.replace(/-/g, "");
          }
          delete x.persona;
        }
      );
      this.$emit("update:content", contenido);
    }
  }
  @Watch("codigoDocAdicionales", { immediate: true })
  async onCodigoDocAdicionalesChange(value: string) {
    if (value) {
      this.nameValue = await new BaseRepository<NameValue>("namevalues").one(
        `codigo="${value}"`
      );
    }
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    return this.validateRefCollection("documentos");
  }
}
